<template>
    <div>
      <mail-to-read-list></mail-to-read-list>
    </div>
  </template>
  <script>
  export default {
  }
  </script>